import { FC, useContext, useEffect } from "react";
import { TeamContext, UserContext } from "../context";
import { LogInPage } from "../pages";

const LoginRoute: FC<{}> = () => {
    const { teamNumber } = useContext(TeamContext);
    const { userData } = useContext(UserContext);

    useEffect(() => {
        if (teamNumber && userData)
            window.location.reload();
    }, []);
    
    return (
        <div>
           {(!teamNumber || !userData) && <LogInPage />}
        </div>
    );
}

export default LoginRoute;